import { Injectable } from '@angular/core';
import { ApiHttpClient } from '../../http/clients/api';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';
import { DealNote } from 'app/models/dto/dealNote.model';

const baseUrl = `${environment.API_URL}`;

@Injectable()
export class DealNoteService {

  constructor(private http: ApiHttpClient) {}

  // gets all deal notes for a borrower by borrowerId
  getDealNotes(dealId: number): Observable<DealNote[]> {
    return this.http.get<DealNote[]>(`${baseUrl}/deal/${dealId}/deal-note`);
  }

  // save a new deal note
  save(dealNote: DealNote): Observable<DealNote> {
    return this.http.post<DealNote>(`${baseUrl}/deal-note`, dealNote);
  }

  // delete a single deal note by dealNoteId
  delete(dealNoteId: number): Observable<number> {
    return this.http.delete<number>(`${baseUrl}/deal-note/${dealNoteId}`);
  }

  // update a single deal note by dealNoteId
  update(dealNoteId: number, updatedNote: string): Observable<DealNote> {
    return this.http.put<DealNote>(`${baseUrl}/deal-note/${dealNoteId}`, { content: updatedNote });
  }
}
